module.exports = __webpack_public_path__ + "assets/CircleTangentCCDetailed.f162b8e6d448dd06dbdc9e9887c533c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/CircleTangentCCDetailed.png
// module id = 490
// module chunks = 0